<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<ng-container *ngIf="!hasError">
  <div class="sub-container" [attr.aria-busy]="isBusy">
    <div class="busy-backdrop" *ngIf="isBusy"></div>
    <div class="header">
      <div class="analysis-name">{{ analysis?.AnalysisName }}</div>
      <app-buttons
        name="Annotation"
        buttonType="mat-flat-button"
        buttonStyle="btn-filled-small"
        (buttonClickEvent)="onAnnotationClick()"></app-buttons>
      <app-buttons
        name="Filter"
        buttonType="mat-flat-button"
        buttonStyle="btn-filled-small"
        (buttonClickEvent)="onFilterClick()"></app-buttons>
      <app-buttons
        name="Reports"
        buttonType="mat-flat-button"
        buttonStyle="btn-filled-small"
        (buttonClickEvent)="onReportsClick()"></app-buttons>
    </div>
    <div class="tabs-container">
      <mat-tab-group
        [(selectedIndex)]="selectedIndex"
        [mat-stretch-tabs]="false"
        class="no-slide-tabs"
      >
        <mat-tab label="Stats View">
          <ng-template matTabContent>
            <app-hce-stats-view
              *ngIf="analysis"
              [analysis]="analysis"
              [sv]="baseSV"
              [refNameMap]="refNameMap"
              (svStatsCellFilter)="onSvStatsCellFilter($event)"
              (assemblyStatsCellFilter)="onAssemblyStatsCellFilter($event)"
            ></app-hce-stats-view>
          </ng-template>
        </mat-tab>
        <mat-tab label="Results Summary View">
          <ng-template matTabContent>
            <app-hce-results-summary-view
              *ngIf="analysis && (refNameMap | keyvalue).length > 0"
              [analysis]="analysis"
              [sv]="filterSV"
              [refNameMap]="refNameMap"
              [filterRefNameMap]="filterRefNameMap"
              [selectedAnnotationFiles]="selectedAnnotationFiles"
              [selectedAnnotationByFile]="selectedFilterAnnotationByFile">
            </app-hce-results-summary-view>
          </ng-template>
        </mat-tab>
        <mat-tab label="SV List View">
          <ng-template matTabContent>
            <app-hce-sv-list-view
              *ngIf="analysis && (refNameMap | keyvalue).length > 0"
              [analysis]="analysis"
              [sv]="filterSV"
              [refNameMap]="refNameMap"
              [selectedAnnotationFiles]="selectedAnnotationFiles"
              [selectedAnnotationByFile]="selectedAnnotationByFile"
            ></app-hce-sv-list-view>
          </ng-template>
        </mat-tab>
        <mat-tab label="Ref Gene List View">
          <ng-template matTabContent>
            <app-hce-ref-gene-list-view
              *ngIf="analysis && (refNameMap | keyvalue).length > 0"
              [analysis]="analysis"
              [sv]="filterSV"
              [refNameMap]="refNameMap"
              [filtered]="filtered"
              [selectedAnnotationFiles]="selectedAnnotationFiles"
            ></app-hce-ref-gene-list-view>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</ng-container>
